import React from 'react'

export const BurgerOpen = ({ width, height }) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={ width ? width : "34" } height={ height ? height : "34" } viewBox="0 0 34 34" fill="none">
            <path fill="#fff" d="M24.5 17a.624.624 0 0 1-.625.625h-13.75a.625.625 0 1 1 0-1.25h13.75A.624.624 0 0 1 24.5 17Zm-14.375-4.375h13.75a.624.624 0 1 0 0-1.25h-13.75a.625.625 0 1 0 0 1.25Zm13.75 8.75h-13.75a.625.625 0 1 0 0 1.25h13.75a.624.624 0 1 0 0-1.25Z"/>
        </svg>
    )
}